import React from "react"
import { DataAccess } from "../Models/Client/DataAccess"

export const DataAccessContext = React.createContext<DataAccess>(
    DataAccess.owner
)
